<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-06-01 16:26:25
 * @Description: 领导人详情弹框
-->
<template>
  <el-dialog :visible.sync="isShow">
    <div>
      <img width="780" height="400" :src="teamDetail.icon">
    </div>
    <div class="content ql-snow ql-editor" v-html="teamDetail.introduction"></div>
  </el-dialog>
</template>
<script>
  export default {
      props: {
          value: Boolean,
          teamDetail: {
              type: Object,
              default: () => {
                  return {}
              }
          }
      },
      data() {
          return {
              isShow: this.value
          }
      },
      watch: {
          value(n, o) {
              this.isShow = n;
          },
          isShow(n, o) {
              this.$emit('input', n)
          }
      }
  }
</script>
<style lang="less" scoped>
  .team-detail {
      display: flex;

      .cell {
        width: 780px;
        height: 300px;
      }

      .leader {
          margin-left: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .p1 {
              color: #394f9a;
              font-size: 32px;
              font-weight: 500;
              margin-bottom: 20px;
          }

          .p2 {
              margin-bottom: 10px;
              word-break: break-word;
          }
      }

      .content {
          padding: 30px 30px 0 260px;
          position: relative;

          &:before {
              position: absolute;
              content: " ";
              width: 60%;
              height: 0;
              border: 1px solid #d9d9d9;
              top: 0;
          }
      }
  }

  /deep/ .el-dialog {
      width: 780px;
      // height: 520px;
      .el-dialog__body, .el-dialog__header {
          padding: 0;
          background-color: #fff;
      }
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
      /deep/ .el-dialog {
          width: 350px;
      }

      .team-detail {
          flex-direction: column;
          align-items: flex-start;

          img {
              object-fit: contain;
          }

          .leader {
              margin-left: 0;

              .p1 {
                  font-size: 22px;
                  margin-bottom: 0;
              }

              .p1, .p2 {
                  padding: 10px 20px;
              }

              .p2 {
                  margin-bottom: 0;
              }
          }

          .content {
              padding: 20px;

              &:before {
                  position: absolute;
                  content: " ";
                  width: 90%;
                  height: 0;
                  border: 1px solid #d9d9d9;
                  top: 0;
              }
          }
      }
  }
</style>
